<div #container [ngClass]="{'ct-multiselect ui-multiselect ct-full-width':true,'ui-multiselect-open':overlayVisible,'ui-state-disabled': disabled, 'active': overlayVisible}"
     [ngStyle]="style" [class]="styleClass" (click)="onMouseclick($event, input)">
    <div class="ui-helper-hidden-accessible">
        <input #input readonly="readonly" [attr.id]="inputId" [attr.name]="name"
               [disabled]="disabled" [attr.tabindex]="tabindex"
               (focus)="onInputFocus($event)"
               (blur)="onInputBlur($event)"
               (keydown)="onKeyDown($event)">
    </div>

    <div class="ct-select" [title]="getTitle()">
        <label class="mat-select-value-text">
            {{getTitle()}}
            <i [ngClass]="overlayVisible ? 'fa fa-angle-up' : 'fa fa-angle-down'"></i>
        </label>
    </div>

    <div *ngIf="overlayVisible" [ngClass]="['ui-multiselect-panel']" [@overlayAnimation]="{value: 'visible', params: {showTransitionParams: showTransition, hideTransitionParams: hideTransition}}" (@overlayAnimation.start)="onOverlayAnimationStart($event)"
         [ngStyle]="panelStyle" [class]="panelStyleClass" (click)="panelClick = true"  (click) = "$event.stopPropagation()">
        <div class="ui-multiselect-panel ui-widget ui-widget-content ui-shadow">
            <div class="ct-search-filter" *ngIf="showFilterSearch">
                <input #filterInput [value]="filterValue||''" [attr.aria-label]="ariaFilterLabel"
                       [attr.placeholder]="'Search'"
                       [(ngModel)]="filterValue"
                       (input)="onFilterInput($event)">
                <i class="fa fa-search"></i>
                <i class="fa fa-times" (click)="clearFilter()"></i>
            </div>
            <div class="ui-multiselect-select-all-container" *ngIf="showActionsPanel">
                <ul>
                    <li *ngIf="value?.length"><a (click)="selectNone($event)">Deselect All</a></li>
                    <li *ngIf="!value?.length"><a (click)="selectAllItems($event)">Select All</a></li>
                    <li *ngIf="extraActionTitle"><a (click)="doExtraAction($event)">{{extraActionTitle}}</a></li>
                </ul>
            </div>

            <div #slimScroll="slimScroll" slimScroll [ctSlimScrollArrows]="slimScroll" [style.max-height]="scrollHeight||'auto'">
                <ul class="ui-multiselect-items ui-helper-reset">
                    <li *ngFor="let option of _filteredOptions; let i = index" class="ui-multiselect-item" (click)="onItemClick($event,option)"
                        [style.display]="isItemVisible(option) ? 'block' : 'none'" [ngClass]="{'selected':isSelected(option.value), 'ui-state-disabled': option.disabled || (maxSelectionLimitReached && !isSelected(option.value))}">
                        <div class="ui-chkbox">
                            <div class="ui-helper-hidden-accessible">
                                <input #itemcb type="checkbox" [checked]="isSelected(option.value)" (focus)="focusedItemCheckbox=itemcb" (blur)="focusedItemCheckbox=null" [attr.aria-label]="option.label" [disabled]="option.disabled || (maxSelectionLimitReached && !isSelected(option.value))">
                            </div>
                            <div class="ui-chkbox-box" [ngClass]="{'ui-state-focus': (focusedItemCheckbox === itemcb)}">
                                <span class="ui-chkbox-icon ui-clickable" [ngClass]="{'fa fa-check':isSelected(option.value)}"></span>
                            </div>
                        </div>
                        <label [class.ct-archived-option]="!option.isActive" *ngIf="!itemTemplate">{{option.label}}</label>
                        <ng-container *ngTemplateOutlet="itemTemplate; context: {$implicit: option, index: i}"></ng-container>
                    </li>
                </ul>
            </div>

            <div class="ct-multiselect-panel-footer clearfix" *ngIf="showSubmitButton">
                <button mat-raised-button (click)="submit($event)" class="ct-blue-button">Apply</button>
            </div>
        </div>
    </div>
</div>
